import { CommonModule } from '@angular/common'
import { Component, Input, TemplateRef } from '@angular/core'
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms'
import { DasherizePipe } from '@ftr/foundation'

let nextId = 0

@Component({
  selector: 'ftr-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.css'],
  imports: [CommonModule, DasherizePipe, ReactiveFormsModule],
})
export class RadioComponent<TValue> {
  @Input() id = `ftr-radio-${nextId++}`
  @Input() label: string
  @Input() summary?: string
  @Input() summaryTemplate: TemplateRef<never> | null = null
  @Input() name: string
  @Input() value: TValue
  @Input() control: UntypedFormControl
}
